import styles from "./ProgressBar.module.css";

const clampPercent = (value) => {
  if (value == null || Number.isNaN(Number(value))) {
    return 0;
  }
  return Math.min(100, Math.max(0, Math.round(Number(value))));
};

const ProgressBar = ({ value = 0, className = "", valueClassName = "" }) => {
  const percent = clampPercent(value);

  return (
    <div className={`${styles.root} ${className}`.trim()}>
      <div
        className={styles.track}
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div className={styles.fill} style={{ width: `${percent}%` }} />
      </div>
      <span className={`${styles.value} ${valueClassName}`.trim()}>
        {percent}%
      </span>
    </div>
  );
};

export default ProgressBar;
